export const isTouchDevice = () => {
  const anyNavigator = window.navigator as any;
  const msMaxTouchPoints = anyNavigator['msMaxTouchPoints'] as number | undefined;
  const hasOnTouchStart = ('ontouchstart' in window);
  const result = hasOnTouchStart  || (!!msMaxTouchPoints && msMaxTouchPoints > 0) || (window.navigator.maxTouchPoints > 0);
  return result;
};

export const getBrowserLanguage = () => {
  const nav = window.navigator as any;
  const language = (nav.language ?? nav.userLanguage) as string;
  return language;
};

export const uses12HourTime = (locale: string) => {
  const hour: 'numeric' | '2-digit' | undefined = 'numeric';
  const options = { hour };
  const formatter = new Intl.DateTimeFormat(locale, options);
  const formattedTime = formatter.format(new Date());

  const is12Hour = formattedTime.includes('AM') || formattedTime.includes('PM');
  return is12Hour;
}

export const browserUses12HourTime = () => {
  const locale = getBrowserLanguage();
  return uses12HourTime(locale);
}